import { useUserProfile } from "@/hooks/useUserProfile";
import { OrdersTab } from "@/pages/admin/components/OrdersTab";
import { QuickBooksExportDialog } from "./QuickBooksExportDialog";

export default function AccountingOrdersPage() {
  const { authUserId } = useUserProfile();

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Orders</h1>
          <p className="text-muted-foreground mt-1">
            Admin orders list with internal and customer invoice links per row.
          </p>
        </div>
        <QuickBooksExportDialog authUserId={authUserId ?? undefined} />
      </div>
      <OrdersTab
        authUserId={authUserId ?? undefined}
        orderScope="orders"
        showSplitPaymentStatusColumn
      />
    </div>
  );
}
